import {observer} from "mobx-react";
import {useSearchParams} from "react-router";
import {useEffect, useState} from "react";

interface SortableTableHeaderProps {
    children: React.ReactNode
    field: string
}

type SortOrder = 'DESC' | 'ASC'

const SortableTableHeader = observer(function SortableTableHeader({
                                                                      children,
                                                                      field,
                                                                  }: SortableTableHeaderProps) {


    const [searchParams, setSearchParams] = useSearchParams()
    const sortByS = searchParams.get('sortBy') || undefined
    const sortOrderS = searchParams.get('sortType') as SortOrder || undefined
    const [sortBy, setSortBy] = useState(sortByS)
    const [sortOrder, setSortOrder] = useState<SortOrder | undefined>(sortOrderS)


    useEffect(() => {
        if (searchParams.get('sortBy') === field){
            setSortOrder(searchParams.get('sortType') === 'DESC' ? 'DESC' : 'ASC')
        } else {
            setSortOrder(undefined)
        }

        setSortBy(searchParams.get('sortBy') || undefined)

    }, [searchParams, setSortBy, setSortOrder, field])


    return <th style={{cursor: 'pointer'}} onClick={() => {
        searchParams.set('sortBy', field)
        searchParams.set('sortType', field !== sortBy ? 'ASC' : sortOrder === 'ASC' ? 'DESC' : 'ASC')
        setSearchParams(searchParams)
    }}>
        <div className="is-flex is-justify-content-space-between">
            {children} {sortOrder && <i className="material-symbols-outlined">{
                sortOrder === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
        }</i>}
        </div>
    </th>
})

export {
    SortableTableHeader
}
